export type PaymentCallbackStatus = "verifying" | "success" | "failed";

export function paymentHeadline(status: PaymentCallbackStatus): string {
  if (status === "verifying") return "Confirming your payment";
  if (status === "success") return "Payment received";
  return "Payment not confirmed";
}

export function paymentDetail(input: {
  status: PaymentCallbackStatus;
  hasReference: boolean;
  registration: boolean;
  thesis: boolean;
  digitalResource: boolean;
}): string {
  if (input.status === "verifying") {
    return "This usually takes a few seconds. Keep this page open.";
  }
  if (input.status === "failed") {
    if (!input.hasReference) {
      return "This link has no payment reference. Open your invoice and try the payment again.";
    }
    return "We could not confirm this payment yet. If money left your account, open My invoices in a few minutes and use Verify payment.";
  }
  if (input.registration) {
    return "Your registration fee is paid. You can use the library now.";
  }
  if (input.thesis) {
    return "Your thesis payment is in. Printing can start, and you will hear when it is ready.";
  }
  if (input.digitalResource) {
    return "Your payment was received. You can download the resource from Paid Resources.";
  }
  return "Your payment is recorded. Keep the receipt for your records.";
}

export function paymentNextSteps(
  registration: boolean,
  thesis: boolean,
  digitalResource: boolean
): string[] {
  if (registration) {
    return ["Save your receipt.", "Browse the catalog when you are ready to borrow."];
  }
  if (thesis) {
    return ["Save your receipt.", "Track the print from My theses."];
  }
  if (digitalResource) {
    return ["Save your receipt.", "Open Paid Resources to download your PDF."];
  }
  return ["Save your receipt.", "Return to the library portal when you are done."];
}
